import { createRouter, createWebHistory } from "vue-router";
import Intro from "../components/Intro.vue";

// import DragnDrop from "../components/DragnDrop.vue"
import Audio from "../components/3_Audio/Audio.vue"
import AufbauOhr from "../components/2_Aufbau_Fkt/AufbauOhr.vue"
import Außenohr from "../components/2_Aufbau_Fkt/Außenohr.vue"
import Mittelohr from "../components/2_Aufbau_Fkt/Mittelohr.vue"
import Innenohr from "../components/2_Aufbau_Fkt/Innenohr.vue"
// import MultipleChoice from "../components/MultipleChoice.vue"
import AufbauQuiz from "../components/2_Aufbau_Fkt/Aufbau_Quiz.vue"
import AufbauPraxis from "../components/2_Aufbau_Fkt/Aufbau_Praxis.vue"
import AudioQuiz from "../components/3_Audio/AudioQuiz.vue"
import AudioPraxis from "../components/3_Audio/Audio_Praxis.vue"
import PhysikalischeGrundlagen from "../components/3_Audio/Physikalische_Grundlagen.vue"
import Signale from "../components/3_Audio/Signale.vue"

import Audiosignale from "../components/3_Audio/Audiosignale.vue"
import Audiokurs from "../components/3_Audio/Audiokurs.vue"


const routes = [
  {
    path: "/",
    name: "Intro",
    component: Intro,
  },
  {
    path: "/AufbauOhr",
    name: "Aufbau Ohr",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: AufbauOhr,
  },
  // {
  //   path: "/DragnDrop",
  //   name: "DragnDrop",
  //   component: DragnDrop,
  // },
  {
    path: "/Audio",
    name: "Audio",
    component: Audio,
  },
  {
    path: "/PhysikalischeGrundlagen",
    name: "PhysikalischeGrundlagen",
    component: PhysikalischeGrundlagen,
  },
  {
    path: "/Signale",
    name: "Signale",
    component: Signale,
  },
  {
    path: "/Audiosignale",
    name: "Audiosignale",
    component: Audiosignale,
  },
  {
    path: "/Audiokurs",
    name: "Audiokurs",
    component: Audiokurs,
  },

  {
    path: "/Außenohr",
    name: "Außenohr",
    component: Außenohr,
  },
  {
    path: "/Mittelohr",
    name: "Mittelohr",
    component: Mittelohr,
  },
  // {
  //   path: "/MultipleChoice",
  //   name: "MultipleChoice",
  //   component: MultipleChoice,
  // },
  {
    path: "/Innenohr",
    name: "Innenohr",
    component: Innenohr,
  },
  {
    path: "/AufbauQuiz",
    name: "AufbauQuiz",
    component: AufbauQuiz,
  },
  {
    path: "/AufbauPraxis",
    name: "AufbauPraxis",
    component: AufbauPraxis,
  },
  {
    path: "/AudioQuiz",
    name: "AudioQuiz",
    component: AudioQuiz,
  },
  {
    path: "/AudioPraxis",
    name: "AudioPraxis",
    component: AudioPraxis,
  },

  

  
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
